// extracted by mini-css-extract-plugin
module.exports = {"form":"outPatientCostStatistics_form__2FME_","total":"outPatientCostStatistics_total__287Ez"};